import React, { FC } from 'react';

import { NumberSignEnum } from '../../../../lib/enums';
import { Week52HighLowResponse } from '../../../../lib/models/fundamental/types';
import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrency } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import styles from '../../Week52GainersAndLosers.module.scss';

type Props = { item: Week52HighLowResponse }

const PriceAndChange: FC<Props> = (props: Props): JSX.Element => {
  const { item } = props;
  if (!item.lastPrice) {
    return <>{INVALID_VALUE}</>;
  }

  const { symbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(symbol, 'SymbolTradeInfoCard');
  const color = getPriceColorByDirection(direction);

  return (
    <>
      <td>
        <span className={styles.lastPrice}>
          {formatCurrency(currentPrice ?? item.lastPrice)}
        </span>
      </td>
      <td>
        <div className={styles.priceAndChangeContainer}>
          {
            currentPrice && (
              <span style={{ color }}>
                (
                {direction}
                {changePercent}
                )
              </span>
            )
          }
          {
            !currentPrice && INVALID_VALUE
          }
          <span className={item.changePercent > 0 ? styles.positive : styles.negative}>
            (
            {item.changePercent > 0 && NumberSignEnum.Positive}
            {(item.changePercent).toFixed(2)}
            %)
          </span>
        </div>
      </td>
    </>
  );
};

export default PriceAndChange;
